// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"924":"69e775f190c0efbd","2825":"9bfd2ed95af475b6","6254":"b013420242ac4bbc"}[chunkId] + ".js";
};